<template>
<div class="text-center my-5">
    <h4 :style="{color: $store.state.healthyHabits.chart.color}">{{$t('calendar')}} <b-icon-question-circle class="info-title" @click.prevent="$store.state.healthyHabits.showCalendarLegendModal = true"></b-icon-question-circle></h4>
    <div id="healthyHabitsCalendarContainer"></div>
</div>
</template>
<script>
import healthyHabitsMixin from '@/mixins/healthyHabits.mixin'
import { BTooltip, BIcon } from 'bootstrap-vue'

export default {
   name: 'healthyHabitsCalendar',
   props: {
   },
   components: {
    BTooltip,
    BIcon
   },
   mounted () {
    this.generateCalendar()
   },
   mixins: [healthyHabitsMixin],
   data () {
    return {
    }
   },
   methods: {
   }
}
</script>
<style lang="scss">
.cell-style {
    color: white;
    border-radius: 15px;
    width: 25px;
    height: 25px;
    text-align: center;
    cursor: pointer;
    font-size: 0.8rem;
    @include media(mobile) {
        width: 20px;
        height: 20px;
    }
}
.center-table {
    margin-left: auto;
    margin-right: auto;
}
.cell-header {
    max-width: 25px;
    font-size: 0.9rem;
    @include media(mobile) {
        font-size: 0.7rem;
    }
}
.cell-week-day {
    font-size: 0.9rem;
    @include media(mobile) {
        font-size: 0.7rem;
    }
}
table#healthyHabitsCalendar {
    @include media(mobile) {
        table-layout: fixed;
        width: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/views/healthy-habits/HealthyHabitsCalendar.vue